import {
  SHOPIFY_SHOP_ORIGINS,
  ShopifyStore,
} from 'lib/commerce/shopify/shopifyHelper';

/** Hostname of the production storefront this shop already checks out against. */
export function tripleWhaleShop(store: string | null | undefined): string | null {
  if (!store || !(store in SHOPIFY_SHOP_ORIGINS)) return null;
  return new URL(SHOPIFY_SHOP_ORIGINS[store as ShopifyStore]).hostname;
}

/**
 * Headless bootstrap Neha sent, version 2.17.
 * The shop name is the storefront's own Shopify shop.
 */
export function tripleWhaleSnippet(shop: string): string {
  return `window.TriplePixelData={TripleName:${JSON.stringify(shop)},ver:"2.17",plat:"SHOPIFY",isHeadless:true},function(W,H,A,L,E,_,B,N){function O(U,T,P,H,R){void 0===R&&(R=!1),H=new XMLHttpRequest,P?(H.open("POST",U,!0),H.setRequestHeader("Content-Type","text/plain")):H.open("GET",U,!0),H.send(JSON.stringify(P||{})),H.onreadystatechange=function(){4===H.readyState&&200===H.status?(R=H.responseText,U.includes("/first")?eval(R):P||(N[B]=R)):(299<H.status||H.status<200)&&T&&!R&&(R=!0,O(U,T-1,P))}}if(N=window,!N[H+"sn"]){N[H+"sn"]=1,L=function(){return Date.now().toString(36)+"_"+Math.random().toString(36)};try{A.setItem(H,1+(0|A.getItem(H)||0)),(E=JSON.parse(A.getItem(H+"U")||"[]")).push({u:location.href,r:document.referrer,t:Date.now(),id:L()}),A.setItem(H+"U",JSON.stringify(E))}catch(e){}var i,m,p;A.getItem(""+H+"C")||(_=A,A=N,A[H]||(E=A[H]=function(t,e,a){return void 0===a&&(a=[]),"State"==t?E.s:(W=L(),(E._q=E._q||[]).push([W,t,e].concat(a)),W)},E.s="Installed",E._q=[],E.ch=W,B="configSecurityConfModel",N[B]=1,O("https://conf.config-security.com/model",5),i=L(),m=A[atob("c2NyZWVu")],_.setItem("di_pmt_wt",i),p={id:i,action:"profile",avatar:_.getItem("auth-security_rand_salt_"),time:m[atob("d2lkdGg=")]+"."+m[atob("aGVpZ2h0")],host:A.TriplePixelData.TripleName,plat:A.TriplePixelData.plat,url:window.location.href.slice(0,500),ref:document.referrer,ver:A.TriplePixelData.ver},O("https://api.config-security.com/event",5,p),O("https://api.config-security.com/first?host="+A.TriplePixelData.TripleName+"&plat="+A.TriplePixelData.plat,5)))}}("","TriplePixel",localStorage);`;
}

export const TRIPLE_WHALE_HOSTS = [
  'https://api.config-security.com',
  'https://conf.config-security.com',
] as const;

type TriplePixelFn = (
  event: string,
  payload?: Record<string, unknown>,
) => void;

export type TripleWhaleCartLine = {
  item: string;
  q: number;
  v: string;
};

/** Numeric Shopify ids only. A SKU is not a product id Triple Whale can match. */
export function tripleWhaleCartLines(
  items: Array<{ item_id?: string; quantity?: number }>,
): TripleWhaleCartLine[] {
  const lines: TripleWhaleCartLine[] = [];
  for (const item of items) {
    if (!item.item_id || !/^\d+$/.test(item.item_id)) continue;
    const quantity = item.quantity;
    lines.push({
      item: item.item_id,
      q: typeof quantity === 'number' && quantity > 0 ? quantity : 1,
      v: item.item_id,
    });
  }
  return lines;
}

export function trackTripleWhaleAddToCart(
  items: Array<{ item_id?: string; quantity?: number }>,
): void {
  if (typeof window === 'undefined') return;
  const triplePixel = (window as Window & { TriplePixel?: TriplePixelFn })
    .TriplePixel;
  if (typeof triplePixel !== 'function') return;
  for (const line of tripleWhaleCartLines(items)) {
    triplePixel('AddToCart', line);
  }
}
